<script setup lang="ts">
useHead({
  titleTemplate: '%s',
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
